import { CheckoutJourney } from '../models/checkout-journey.types';
import { CustomerJourneyType } from '../models/checkout.model';

export const RESERVATION_JOURNEY: CheckoutJourney = {
  type: CustomerJourneyType.RESERVATION,
  searchRoute: '/search',
  page: [
    {
      pageRoute: 'addons',
      label: 'Tilvalg',
      ariaLabel: 'Tilvalg',
    },
    {
      pageRoute: 'personal-info',
      label: 'Personlig info',
      ariaLabel: 'Personlig info',
      // Button label comes from availability-type-request.ts ("Send forespørgsel")
      zoneConfig: {
        processingLabel: 'Sender anmodning...',
      },
    },
    {
      pageRoute: 'complete',
      label: 'Bekræftelse',
      ariaLabel: 'Bekræftelse',
      zoneConfig: {
        summaryContent: {
          title: 'Forespørgsel sendt',
          message: 'Din forespørgsel er sendt til godkendelse.',
          illustrationPath: './assets/illustrations/checkout-goalline.svg',
        },
      },
    },
  ],
};
